'use strict';

const stringsComuns = require('./comum');

module.exports = {
    acessos: 'Acessos',
    permissoes: 'Permissões',
    colecao: {
        criacao: {
            confirmar: 'Confirmar a criação da coleção?',
            erro: 'Houve um erro ao criar a coleção',
            sucesso: 'Coleção criada com sucesso',
        },
        edicao: {
            confirmar: 'Confirmar a edição da coleção?',
            erro: 'Houve um erro ao editar a coleção',
            sucesso: 'Coleção editada com sucesso',
        },
        editar: 'Editar coleção',
        exclusao: {
            confirmar: 'Tem certeza que deseja remover esta coleção?',
            erro: 'Houve um erro ao remover a coleção. Tente novamente mais tarde.',
            sucesso: 'Coleção removida com sucesso',
        },
        imagem: {
            validacao: {
                erro: {
                    formato: 'A imagem da coleção deve ser quadrada (ex: 500x500)',
                },
            },
        },
        colecaoFiltroManual: 'Escolha como deseja criar a coleção:',
        escolherFiltros: 'Selecionar filtros',
        insercaoManual: 'Inserção manual',
        inserirExame: 'Inserir exame',
        upload: {
            selecionarArquivoZip: 'Selecionar arquivo(s) .zip',
            arrasteOuClique: 'Arraste os arquivos aqui ou clique para selecionar',
            apenasZip: 'Apenas arquivos .zip são permitidos',
            confirmar: 'Confirmar envio dos exames selecionados?',
            erroApenasZip: 'Apenas arquivos .zip são permitidos',
            enviando: 'Enviando arquivos...',
            processandoEstudo: 'Processando estudo na Bridge...',
            sucesso: 'Exames enviados e processados com sucesso',
            erroEnviar: 'Erro ao enviar os exames',
            erroProcessamento: 'Erro ao processar o estudo na Bridge',
            erroColecaoNaoSelecionada: 'Nenhuma coleção selecionada para o upload',
            erroVincular: 'Erro ao vincular o estudo DICOM à coleção',
            loteInterrompido: 'Lote interrompido após falha no processamento.',
        },
        ambas: 'Ambas',
        tipoInsercaoDocumentos: 'Inserção de documentos',
        novaColecao: 'Nova coleção',
        suasColecoes: 'Suas coleções',
        tipoCompartilhamento: {
            link: 'Qualquer pessoa com o link pode visualizar.',
            privada: 'Apenas pessoas com acesso podem usar o link.',
            publica: 'Visível publicamente na internet para leitura.',
        },
        acesso: {
            acessoRestrito: 'Acesso restrito',
            qualquerPessoaLink: 'Qualquer pessoa com o link',
            ultimoAcesso: 'Último acesso',
            totalAcessos: 'Total de acessos',
            nenhumUsuarioAdicionado: 'Nenhum usuário adicionado',
            editor: 'Editor',
            visualizador: 'Visualizador',
            digiteCpfUsuario: 'Digite o CPF do usuário',
        },
        validacao: {
            descricao: {
                erroMaximo: 'A descrição deve ter no máximo 256 caracteres',
            },
            titulo: {
                erroMaximo: 'O título deve ter no máximo 20 caracteres',
                erroMinimo: 'O título deve ter no mínimo 3 caracteres',
            },
        },
        cor: 'Cor',
        estudosDicom: {
            titulo: 'Processamento de estudos DICOM',
            arquivo: 'Arquivo',
            dataEnvio: 'Data do envio',
            status: 'Status',
            acoes: 'Ações',
            opcoes: 'Opções',
            detalhes: 'Detalhes',
            verTodos: 'Ver todos',
            nenhumEstudo: 'Nenhum estudo DICOM enviado',
            statusPendente: 'Pendente',
            statusProcessando: 'Processando',
            statusSucesso: 'Sucesso',
            statusErro: 'Erro',
            detalhesComando: 'Detalhes do Comando',
            informacoesGerais: 'Informações gerais',
            timelineEventos: 'Timeline de eventos',
            id: 'ID',
            idExame: 'Id do exame',
            tipo: 'Tipo',
            pacs: 'PACS',
            carregandoEventos: 'Carregando eventos...',
            nenhumEvento: 'Nenhum evento registrado para este job.',
            erroCarregarEventos: 'Não foi possível carregar os eventos do job.',
            processandoNaBridge: 'Aguardando processamento na Bridge...',
            aguardandoGeracaoEstudo: 'Aguardando geração do estudo',
            exclusao: {
                confirmar: 'Deseja remover este exame da coleção? O estudo DICOM será removido, mas permanecerá no PACS.',
                sucesso: 'Exame removido da coleção com sucesso',
                erro: 'Erro ao remover o exame da coleção',
            },
        },
        compartilhamento: {
            voceJaPossuiAcessoColecao: 'Você já possui acesso a esta coleção.',
            adicionarColecao: 'Adicionar coleção',
            desejaAdicionarColecao: (titulo) => `Deseja ter acesso a coleção "${titulo}"?`
        }
    },
    colecoes: 'Coleções',
    copiarLink: 'Copiar link',
    criadoPor: 'Criado por',
    documentos: 'Documentos',
    rotulosLaudo: {
        campoObrigatorio: stringsComuns.campoObrigatorio,
        indicadorQualidadeObrigatorio: 'Se a qualidade não for 1, marque os indicadores que se aplicam',
        tituloFormulario: 'Classificação radiográfica de tórax (OIT)',
        cabecalhoPaciente: stringsComuns.paciente,
        qualidadeImagem: '1. Qualidade da imagem',
        grau: 'Grau',
        seNaoGrau1: 'Se não for grau 1, marque todos os que se aplicam',
        outroEspecifique: 'Outro (especifique)',
        parenquima: '2. Alterações parenquimatosas',
        qualquerParenquima: '2A. Há alterações parenquimatosas classificáveis?',
        opacidadesPequenas: '2B. Opacidades pequenas',
        formaTamanho: 'Forma/tamanho',
        primario: 'Primário',
        secundario: 'Secundário',
        zonas: 'Zonas',
        superior: 'Superior',
        medio: 'Médio',
        inferior: 'Inferior',
        profusao: 'Profusão',
        opacidadesGrandes: '2C. Opacidades grandes',
        pleura: '3. Alterações pleurais',
        qualquerPleura: '3A. Há alterações pleurais classificáveis?',
        placasPleurais: '3B. Placas pleurais',
        perfil: 'De perfil',
        face: 'De frente',
        diafragma: 'Diagragma',
        outros: 'Outro(s) local(is)',
        lado: 'Local',
        calcificacao: 'Calcificação',
        extensao: 'Extensão',
        largura: 'Largura (só de perfil)',
        extensaoLegenda: '1 = < 1/4 da parede; 2 = 1/4 a 1/2; 3 = > 1/2',
        larguraLegenda: 'a = 3–5 mm; b = 5–10 mm; c = > 10 mm',
        obliteracao: '3C. Obliteração do ângulo costofrênico',
        espessamento: '3D. Espessamento pleural difuso',
        outras: '4. Outras alterações',
        qualquerOutra: '4A. Há outras alterações?',
        simbolos: '4B. Outros símbolos',
        servicoRadiologia: 'Serviço de radiologia',
        medicoSolicitante: stringsComuns.medicoSolicitante,
        dataLeitura: 'Data da leitura',
        propositoClassificacao: 'Finalidade da classificação',
        tipoLeitura: 'Tipo de leitura',
        nomeMedicoClassificador: 'Nome do médico classificador',
        publicador: 'Publicado por',
        atualizadoEm: 'Atualizado em',
        publicar: stringsComuns.publicar,
        visualizarResumo: stringsComuns.visualizarResumo,
        resumoLaudo: 'Resumo do laudo',
        confirmar: stringsComuns.confirmar,
        cancelar: stringsComuns.cancelar,
        gerandoResumo: 'Gerando resumo...',
        confirmando: 'Confirmando...',
        ok: stringsComuns.ok,
        sucesso: stringsComuns.sucesso,
        erro: stringsComuns.erro,
        salvo: 'Laudo publicado',
        erroSalvar: 'Não foi possível publicar o laudo',
        erroResumo: 'Não foi possível gerar o resumo do laudo',
        erroCarregarLaudo: 'Não foi possível carregar o laudo',
        sim: stringsComuns.sim,
        nao: stringsComuns.nao,
        direita: 'D',
        esquerda: 'E'
    }
};